// extracted by mini-css-extract-plugin
export default {"firstSlide":"FirstSlide_firstSlide__cE+Qi"};